<template>
  <DetailsPane :title="title" @close="$emit('close')">
    <div v-if="coupon.transactions.length > 0" class="usage-details p-4">
      <div v-for="(transaction, i) in coupon.transactions" :key="i" class="row mb-2">
        <div class="col-4 col-attribute">Used By:</div>
        <div class="col-8 col-value">{{ transaction.user.name }}</div>
        <div class="col-4 col-attribute">Company:</div>
        <div class="col-8 col-value">{{ transaction.user.company.name }}</div>
        <div class="col-4 col-attribute">Used For:</div>
        <div class="col-8 col-value">{{ transaction.used_for }}</div>
        <div class="col-4 col-attribute">Discount Amount:</div>
        <div class="col-8 col-value">{{ transaction.coupon_discount | cost }}</div>
        <div class="col-4 col-attribute">Total Cost:</div>
        <div class="col-8 col-value">{{ transaction.amount | cost }}</div>
        <div class="col-4 col-attribute">Purchase Date:</div>
        <div class="col-8 col-value">{{ transaction.created_at | moment("MM/DD/YYYY h:mm A") }}</div>
      </div>
    </div>
    <div v-else class="p-4">
      <div class="alert alert-info">This coupon code has not yet been used.</div>
    </div>
  </DetailsPane>
</template>

<script>
import DetailsPane from "components/listings/DetailsPane";
export default {
  components: { DetailsPane },
  props: {
    coupon: { type: Object, required: true }
  },
  computed: {
    title() {
      return `Usage for Code: ${this.coupon.code}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "bootstrap/scss/_functions";
@import "bootstrap/scss/_variables";
@import "bootstrap/scss/_mixins";
@import "~sass/_variables";

.usage-details {
  font-size: 0.875rem;
  .row {
    border-bottom: 2px solid gray("400");
    padding-bottom: 1rem;
    margin-top: 1rem;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
  .col-attribute {
    color: gray("600");
  }
}
</style>